import {Text} from '@rdcomponents/text/text';
import {Table, Tag} from 'antd';
import {useMemo} from 'react';

import {FormattedDateTime} from '../../../../provider/locale/formatted-date-time';
import {Locale} from '../../../../provider/locale/localization';
import {LangKeyType} from '../../../../provider/locale/translation/type';
import {
    ReviewsAndAnswersFilterQueriesEnum,
    ReviewsAndAnswersFilterStateType,
} from '../../../../service/reviews-and-answers-statistics/filter/reviews-and-answers-statistics-filter-type';
import {getReviewFilters} from '../../../../service/reviews-and-answers-statistics/filter/reviews-and-answers-statistics-helper';

import {useReviewFilterPdfChips} from './use-review-filter-pdf-chips';
import * as styles from './reviews-and-answers-filter-pdf.scss';

type ReviewsAndAnswersPdfFilterTableItemType = {
    periodLangKeyType: LangKeyType;
    start: Date;
    end: Date;
};

type PropsType = {
    filter: ReviewsAndAnswersFilterStateType;
};

export function ReviewsAndAnswersFilterPdf(props: PropsType): JSX.Element {
    const {filter} = props;

    const filterChips = useReviewFilterPdfChips(getReviewFilters(filter));

    const dataSource: Array<ReviewsAndAnswersPdfFilterTableItemType> = useMemo(() => {
        const periodAItem: ReviewsAndAnswersPdfFilterTableItemType = {
            periodLangKeyType: 'REVIEW_AND_ANSWER_STATISTICS__PERIOD_A',
            start: filter[ReviewsAndAnswersFilterQueriesEnum.PeriodStart],
            end: filter[ReviewsAndAnswersFilterQueriesEnum.PeriodEnd],
        };

        const periodBItem: ReviewsAndAnswersPdfFilterTableItemType | null =
            filter[ReviewsAndAnswersFilterQueriesEnum.ComparePeriodStart] &&
            filter[ReviewsAndAnswersFilterQueriesEnum.ComparePeriodEnd]
                ? {
                      periodLangKeyType: 'REVIEW_AND_ANSWER_STATISTICS__PERIOD_B',
                      start: filter[ReviewsAndAnswersFilterQueriesEnum.ComparePeriodStart],
                      end: filter[ReviewsAndAnswersFilterQueriesEnum.ComparePeriodEnd],
                  }
                : null;

        return [periodAItem, ...(periodBItem ? [periodBItem] : [])];
    }, [filter]);

    return (
        <div className={styles.FilterPdf}>
            {filterChips.length > 0 && (
                <div className={styles.FilterPdf_active}>
                    <Text block bolder stringKey="REVIEW_AND_ANSWER_STATISTICS__PDF_FILTER__ACTIVE_TITLE" />
                    <div className={styles.FilterPdf_tags}>
                        {filterChips.map((chip) => (
                            <Tag className={styles.FilterPdf_tag} key={chip.key}>
                                {chip.label}
                            </Tag>
                        ))}
                    </div>
                </div>
            )}

            <Table<ReviewsAndAnswersPdfFilterTableItemType>
                dataSource={dataSource}
                pagination={false}
                rowKey={(record) => record.periodLangKeyType}
            >
                <Table.Column<ReviewsAndAnswersPdfFilterTableItemType>
                    render={(_value, record) => {
                        return <Locale stringKey={record.periodLangKeyType} />;
                    }}
                    title={<Locale stringKey="REVIEW_AND_ANSWER_STATISTICS__PDF_FILTER__COLUMN_PERIOD" />}
                />
                <Table.Column<ReviewsAndAnswersPdfFilterTableItemType>
                    render={(_value, record) => {
                        return <FormattedDateTime value={record.start} />;
                    }}
                    title={<Locale stringKey="REVIEW_AND_ANSWER_STATISTICS__PDF_FILTER__COLUMN_START" />}
                />
                <Table.Column<ReviewsAndAnswersPdfFilterTableItemType>
                    render={(_value, record) => {
                        return <FormattedDateTime value={record.end} />;
                    }}
                    title={<Locale stringKey="REVIEW_AND_ANSWER_STATISTICS__PDF_FILTER__COLUMN_END" />}
                />
            </Table>
        </div>
    );
}
